// extracted by mini-css-extract-plugin
export default {"menu":"SiteMenu_menu__DuTRs","mainMenu":"SiteMenu_mainMenu__VhBkq"};